export default "__VITE_ASSET__b2890770__"